<nb-card-header>
  <i class="ion-social-usd"></i>
  <span class="title">Profit</span>
</nb-card-header>
<nb-card-body>
  <ngx-stats-bar-animation-chart [linesData]="linesData"></ngx-stats-bar-animation-chart>
</nb-card-body>
